import { WebAuth } from 'auth0-js';
import { useEffect } from 'react';
import Heading from '../../components/heading';
import { useGlobalState } from '../globalState/GlobalStateProvider';

interface ExternalProps {
  auth0: WebAuth;
}

const External: React.FC<ExternalProps> = ({ auth0 }: ExternalProps) => {
  const { state } = useGlobalState();
  const { email, connection } = state;

  useEffect(() => {
    auth0.authorize({
      connection,
      login_hint: email,
    });
  }, [auth0, email, connection]);

  return (
    <>
      <Heading title="We sturen je door...">
        <p>Even geduld a.u.b.</p>
      </Heading>
    </>
  );
};

export default External;
